
import dayjs from "dayjs";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default: () => "view",
      validator: (value: string) => {
        return ["view", "edit"].indexOf(value) !== -1;
      },
    },
    error: {
      type: Object as PropType<string | null>,
      required: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (v) => {
        context.emit("update:modelValue", v);
      },
    });

    const date_formatted = computed(() => {
      return dayjs(value.value).format("DD.MM.YYYY");
    });

    return {
      value,
      date_formatted,
    };
  },
});
